<template>
  <div class="my-1 my-md-4">
    <!-- Mobile version: inside expansion panel -->
    <v-expansion-panels v-if="isMobileOrTablet" flat>
      <v-expansion-panel>
        <v-expansion-panel-header> Ver más opciones </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="d-flex flex-column gap-2" dense>
            <v-btn
              block
              class="white-button"
              :disabled="downloading"
              @click="downloadCsv"
            >
              <v-icon class="mr-2"> mdi-microsoft-excel </v-icon>
              {{ !downloading ? 'Descargar excel' : 'Descargando excel...' }}
            </v-btn>
            <email-dialog-form
              ref="emailDialog"
              v-model="email"
              :loading="emailing"
              :disabled="emailing"
              @onFormSubmit="sendEmail"
            />
            <search-input
              width="auto"
              hide-details
              @input="(e) => $emit('onSearch', e)"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Desktop version: normal row -->
    <v-row v-else dense>
      <v-col cols="4">
        <v-btn
          block
          class="white-button"
          :disabled="downloading"
          @click="downloadCsv"
        >
          <v-icon class="mr-2"> mdi-microsoft-excel </v-icon>
          {{ !downloading ? 'Descargar CSV' : 'Descargando CSV...' }}
        </v-btn>
      </v-col>
      <v-col cols="4">
        <email-dialog-form
          ref="emailDialog"
          v-model="email"
          :loading="emailing"
          :disabled="emailing"
          @onFormSubmit="sendEmail"
        />
      </v-col>
      <v-col cols="4">
        <search-input
          width="auto"
          hide-details
          @input="(e) => $emit('onSearch', e)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import EmailDialogForm from '@/components/forms/EmailDialogForm.vue';
  import SearchInput from '@/components/SearchInput.vue';
  import saveFile from '@/mixins/saveFile';

  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'ClearanceListToolbar',

    components: { SearchInput, EmailDialogForm },
    mixins: [saveFile],
    props: {
      customer: {
        type: Number,
        require: true,
      },
      center: {
        type: String,
      },
    },
    data() {
      return {
        search: null,
        email: null,
        emailing: false,
        downloading: false,
      };
    },
    computed: {
      ...mapGetters('auth', ['user']),
    },
    mounted() {
      this.email = this.user.email;
    },
    methods: {
      ...mapActions('clearanceMaterials', ['getCSVFile', 'sendByEmail']),

      async sendEmail(email) {
        this.emailing = true;

        const response = await this.sendByEmail({
          email: email,
          customer: this.customer,
          center: this.center,
        });
        if (response.ok) {
          this.$toast.success('Hemos enviado la lista de productos.');
        } else {
          this.$toast.error(response.message);
        }

        if (this.email !== this.user.email) {
          this.$refs.emailDialog.$refs.emailForm.reset();
        }

        this.emailing = false;
      },

      async downloadCsv() {
        this.downloading = true;

        const response = await this.getCSVFile({
          email: this.email,
          customer: this.customer,
          center: this.center,
        });

        if (response.ok) {
          this.saveFileToDevice(
            response.file,
            'materiales_descontinuados',
            'csv'
          );
        } else {
          this.$toast.error(response.message);
        }

        this.downloading = false;
      },
    },
  };
</script>
